import React from 'react';
import GroupingModeModal, { CLASSIC_GROUPING_MODE_KEYS } from '../../Widgets/GroupingModeModal/GroupingModeModal';

/** `onModeSelect` receives the mode key ('MergeAll' | 'OnePerFile' | 'OnePerPdfPage'). */
const GroupingModeDialog = ({
    open,
    onClose,
    onModeSelect,
    direction,
}) => (
    <GroupingModeModal
        open={open}
        onClose={onClose}
        modes={CLASSIC_GROUPING_MODE_KEYS}
        direction={direction}
        onSelect={(_, key) => onModeSelect(key)}
    />
);

export default GroupingModeDialog;
